import type { KeyboardEvent, MouseEvent } from 'react';
import { useLocation } from 'react-router-dom';

const BILL_DATA_TARGET_ID = 'bill-data';
const SUPPLY_DETAILS_TARGET_ID = 'supply-details';
const MAIN_CONTENT_TARGET_ID = 'main-content';

const hasMainContentTarget = (pathname: string) => {
	const normalizedPathname = pathname.toLowerCase();

	return /\/veritas\/invoice\/(tari|idrico)\/(document\/|document-list\/)/.test(
		normalizedPathname,
	);
};

const hasBillDetailTargets = (pathname: string) => {
	const normalizedPathname = pathname.toLowerCase();

	return /\/veritas\/invoice\/(tari|idrico)\/(document\/|document-list\/[^/]+\/invoice\/)/.test(
		normalizedPathname,
	);
};

const SkipLinks = () => {
	const { pathname } = useLocation();

	const showMainContentLink = hasMainContentTarget(pathname);
	const showBillDetailLinks = hasBillDetailTargets(pathname);

	if (!showMainContentLink && !showBillDetailLinks) return null;

	const onSkipLinkClick = (
		event: MouseEvent<HTMLAnchorElement>,
		targetId: string,
	) => {
		const target = document.getElementById(targetId);

		if (!target) return;

		event.preventDefault();
		target.focus({ preventScroll: true });
		target.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest',
		});
	};

	const onSkipLinkKeyDown = (
		event: KeyboardEvent<HTMLAnchorElement>,
		targetId: string,
	) => {
		if (event.key !== 'Enter') return;

		const target = document.getElementById(targetId);

		if (!target) return;

		event.preventDefault();
		target.focus({ preventScroll: true });
		target.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest',
		});
	};

	return (
		<div className='app-skip-links'>
			{showMainContentLink && (
				<a
					className='app-skip-link'
					href={`#${MAIN_CONTENT_TARGET_ID}`}
					tabIndex={0}
					onClick={(event) => onSkipLinkClick(event, MAIN_CONTENT_TARGET_ID)}
					onKeyDown={(event) =>
						onSkipLinkKeyDown(event, MAIN_CONTENT_TARGET_ID)
					}
				>
					Vai al contenuto principale
				</a>
			)}
			{showBillDetailLinks && (
				<>
					<a
						className='app-skip-link'
						href={`#${BILL_DATA_TARGET_ID}`}
						tabIndex={0}
						onClick={(event) => onSkipLinkClick(event, BILL_DATA_TARGET_ID)}
						onKeyDown={(event) => onSkipLinkKeyDown(event, BILL_DATA_TARGET_ID)}
					>
						Vai ai dati della bolletta
					</a>
					<a
						className='app-skip-link'
						href={`#${SUPPLY_DETAILS_TARGET_ID}`}
						tabIndex={0}
						onClick={(event) =>
							onSkipLinkClick(event, SUPPLY_DETAILS_TARGET_ID)
						}
						onKeyDown={(event) =>
							onSkipLinkKeyDown(event, SUPPLY_DETAILS_TARGET_ID)
						}
					>
						Vai ai dettagli della fornitura
					</a>
				</>
			)}
		</div>
	);
};

export { BILL_DATA_TARGET_ID, MAIN_CONTENT_TARGET_ID, SUPPLY_DETAILS_TARGET_ID };
export default SkipLinks;
